import { useState } from "react";
import { Dialog } from "@headlessui/react";
import styles from "./VerifyEmail.module.css";
import {
  AiFillCheckCircle,
  AiFillCloseCircle,
  AiOutlineClose,
} from "react-icons/ai";

const VerifyEmail = ({ title = "", message = "", success, onVerified }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);
  const statusStyle = success ? styles.success : styles.error;

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      if (onVerified) {
        setIsOpen(false);
        onVerified(); // Calls the function passed from EventGuestList
      }
    }, 500);
  };
  return (
    <Dialog open={isOpen} onClose={closeModal} className={styles.overlay}>
      <Dialog.Overlay />
      <div className={`${styles.modal} ${isClosing ? styles.fadeOut : ""}`}>
        <Dialog.Title as="h3" className={styles.title}>
          <span>{title}</span>
          <span className={styles.btn} onClick={closeModal}>
            <AiOutlineClose className={styles.close} />
          </span>
        </Dialog.Title>
        <Dialog.Description as="div" className={styles.body}>
          <span>
            {success ? (
              <AiFillCheckCircle
                className={`${styles.status} ${statusStyle}`}
              />
            ) : (
              <AiFillCloseCircle
                className={`${styles.status} ${statusStyle}`}
              />
            )}
          </span>
          <div>
            <h3 className={styles.status_title}>
              {success ? "Success" : "Failed"}
            </h3>
            <p className={styles.message}>{message}</p>
          </div>
        </Dialog.Description>
        {/* <button className={styles.button} onClick={closeModal}>
        Ok
        </button> */}
      </div>
    </Dialog>
  );
};

export default VerifyEmail;
